import { FC, useContext } from "react"
import { IconButton } from "@rhumbix/rmbx_design_system_web"
import { SideRailContext } from "../../SideRail/SideRailContext"

/**
 * Header area for the EoD Question Library settings page. The right-hand block holds the
 * "Create a Question" button, which opens the EOD_QUESTION_CREATE side rail form.
 */
export const EodQuestionsSettingsHeader: FC = () => {
    const { enableSideRail } = useContext(SideRailContext)

    return (
        <div className="aggrid-header-container">
            <div className="aggrid-header-title-block-left">
                <header className="aggrid-header-title">End of Day Questions</header>
            </div>
            <div className="aggrid-header-title-block-right">
                <IconButton id="createEodQuestionBtn" text="Create a Question" onClick={() => enableSideRail({ flow: "EOD_QUESTION_CREATE" })} />
            </div>
        </div>
    )
}
